module.exports = __webpack_public_path__ + "img/9.47270baf.png";